import { createSlice } from "@reduxjs/toolkit";

import { type LegislationStateType } from "../interfaces/legislation";

const initialState: LegislationStateType = {
  isLoading: false,
  legislations: [],
};

const legislationSlice = createSlice({
  name: "legislation",
  initialState,
  reducers: {
    setLegislationLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setLegislations: (state, action) => {
      state.legislations = action.payload;
    },
  },
});

export const { setLegislationLoading, setLegislations } =
  legislationSlice.actions;
export default legislationSlice.reducer;
